import { METRIC_NAME_MAPPING, VALID_SLIDE_COUNTS } from './metrics';

/**
 * Validates that a given set of label values match the expected keys and
 * label value of the given metric
 */
export function validateLabelsAndName(metricName: string, labels: Record<string, string>) {
    const metricDefn = METRIC_NAME_MAPPING[metricName];
    if (!metricDefn) {
        // eslint-disable-next-line no-console
        console.error(`Unknown metric name: ${metricName}`);
        return false;
    }

    for (const labelName in metricDefn.labelValueMapping) {
        if (typeof labels[labelName] === 'undefined') {
            return false;
        }
        const actualValue = labels[labelName];
        const expectedValues = metricDefn.labelValueMapping[labelName];
        if (!expectedValues.includes(actualValue)) {
            return false;
        }
    }
    return true;
}

export function formatSlideCount(slideCount: number) {
    if (slideCount <= 10) {
        return VALID_SLIDE_COUNTS.ONE_TO_TEN;
    }
    if (slideCount > 10 && slideCount <= 20) {
        return VALID_SLIDE_COUNTS.ELEVEN_TO_TWNETY;
    }
    if (slideCount > 20 && slideCount <= 30) {
        return VALID_SLIDE_COUNTS.TWENTY_ONE_TO_THIRTY;
    }
    if (slideCount > 30 && slideCount <= 40) {
        return VALID_SLIDE_COUNTS.THIRTY_ONE_TO_FORTY;
    }
    return VALID_SLIDE_COUNTS.FORTY_PLUS;
}
